<app-navbar></app-navbar>

<!-- Hero Section -->
<section class="cgu-hero-section">
  <div class="container">
    <div class="hero-content">
      <h1>Conditions Générales d'Utilisation</h1>
      <p class="hero-subtitle">Dernière mise à jour : {{ lastUpdateDate }}</p>
    </div>
  </div>
</section>

<!-- Table of Contents -->
<section class="toc-section">
  <div class="container">
    <div class="toc-wrapper">
      <h2>Sommaire</h2>
      <ul class="toc-list">
        <li><a (click)="scrollToSection('article-1')">1. Objet</a></li>
        <li><a (click)="scrollToSection('article-2')">2. Mentions légales</a></li>
        <li><a (click)="scrollToSection('article-3')">3. Accès au site</a></li>
        <li><a (click)="scrollToSection('article-4')">4. Services proposés</a></li>
        <li><a (click)="scrollToSection('article-5')">5. Propriété intellectuelle</a></li>
        <li><a (click)="scrollToSection('article-6')">6. Données personnelles</a></li>
        <li><a (click)="scrollToSection('article-7')">7. Cookies</a></li>
        <li><a (click)="scrollToSection('article-8')">8. Responsabilités</a></li>
        <li><a (click)="scrollToSection('article-9')">9. Liens hypertextes</a></li>
        <li><a (click)="scrollToSection('article-10')">10. Droit applicable</a></li>
      </ul>
    </div>
  </div>
</section>

<!-- CGU Content -->
<section class="cgu-content-section">
  <div class="container">
    <div class="content-wrapper">
      
      <!-- Article 1 -->
      <article id="article-1" class="cgu-article">
        <div class="article-number">Article 1</div>
        <h2>Objet</h2>
        <p>
          Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») ont pour objet de définir les modalités et conditions d'utilisation du site web <strong>Digital Alchemy</strong> (ci-après le « Site ») ainsi que les droits et obligations des utilisateurs (ci-après « l'Utilisateur » ou « les Utilisateurs ») dans le cadre de l'utilisation du Site.
        </p>
        <p>
          L'utilisation du Site implique l'acceptation pleine et entière des présentes CGU. Si vous n'acceptez pas ces conditions, nous vous demandons de ne pas utiliser le Site.
        </p>
        <p>
          Digital Alchemy se réserve le droit de modifier à tout moment les présentes CGU. Les modifications entreront en vigueur dès leur mise en ligne. Il est donc recommandé aux Utilisateurs de consulter régulièrement cette page.
        </p>
      </article>

      <!-- Article 2 -->
      <article id="article-2" class="cgu-article">
        <div class="article-number">Article 2</div>
        <h2>Mentions Légales</h2>
        <div class="info-box">
          <h3>Éditeur du site</h3>
          <p><strong>Digital Alchemy</strong></p>
          <p>Agence de Marketing Digital et Création de Sites Web</p>
          <p>5ème étage, N°27, Akram Offices</p>
          <p>Av. Arabie Saoudite, Agdal</p>
          <p>90000 Rabat, Maroc</p>
        </div>
        <div class="info-box">
          <h3>Contact</h3>
          <p><strong>Email :</strong> Digitalalchemyma&#64;gmail.com</p>
          <p><strong>Téléphone (Maroc) :</strong> +212 690 459 525</p>
          <p><strong>Téléphone (France) :</strong> +33 1 23 45 67 89</p>
        </div>
        <div class="info-box">
          <h3>Hébergement</h3>
          <p>Le site est hébergé par un prestataire professionnel garantissant la sécurité et la disponibilité des données.</p>
        </div>
      </article>

      <!-- Article 3 -->
      <article id="article-3" class="cgu-article">
        <div class="article-number">Article 3</div>
        <h2>Accès au Site</h2>
        <p>
          Le Site est accessible gratuitement à tout Utilisateur disposant d'un accès à Internet. Tous les coûts afférents à l'accès au Site, que ce soient les frais matériels, logiciels ou d'accès à Internet, sont exclusivement à la charge de l'Utilisateur.
        </p>
        <p>
          Digital Alchemy met en œuvre tous les moyens raisonnables à sa disposition pour assurer un accès de qualité au Site. Cependant, Digital Alchemy ne peut garantir :
        </p>
        <ul>
          <li>L'absence d'interruptions ou d'erreurs dans l'accès au Site</li>
          <li>L'absence de virus ou autres éléments nuisibles</li>
          <li>La continuité du service en cas de maintenance ou de force majeure</li>
        </ul>
        <p>
          Digital Alchemy se réserve le droit de suspendre, d'interrompre ou de limiter l'accès à tout ou partie du Site, notamment en cas de maintenance, sans préavis et sans droit à indemnités.
        </p>
      </article>

      <!-- Article 4 -->
      <article id="article-4" class="cgu-article">
        <div class="article-number">Article 4</div>
        <h2>Services Proposés</h2>
        <p>
          Digital Alchemy propose les services suivants via son Site :
        </p>
        <ul>
          <li><strong>Création de sites web :</strong> Conception et développement de sites internet sur mesure</li>
          <li><strong>Référencement SEO :</strong> Optimisation du positionnement sur les moteurs de recherche</li>
          <li><strong>Publicité en ligne :</strong> Gestion de campagnes publicitaires digitales</li>
          <li><strong>Gestion des réseaux sociaux :</strong> Animation et développement de la présence sociale</li>
          <li><strong>Design graphique :</strong> Création d'identité visuelle et supports de communication</li>
          <li><strong>Marketing digital :</strong> Stratégies digitales complètes</li>
        </ul>
        <p>
          Les informations fournies sur le Site le sont à titre indicatif. Digital Alchemy s'efforce de fournir des informations aussi précises que possible mais ne peut garantir l'exactitude, la complétude et l'actualité des informations diffusées sur le Site.
        </p>
        <p>
          Les prestations de services font l'objet de devis personnalisés et de contrats spécifiques conclus entre Digital Alchemy et ses clients.
        </p>
      </article>

      <!-- Article 5 -->
      <article id="article-5" class="cgu-article">
        <div class="article-number">Article 5</div>
        <h2>Propriété Intellectuelle</h2>
        <p>
          L'ensemble du contenu du Site (textes, images, vidéos, logos, icônes, sons, logiciels, bases de données, etc.) est la propriété exclusive de Digital Alchemy ou fait l'objet d'une autorisation d'utilisation.
        </p>
        <p>
          Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du Site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Digital Alchemy.
        </p>
        <p>
          Toute exploitation non autorisée du Site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
        </p>
        <div class="warning-box">
          <strong>⚠️ Avertissement :</strong> L'utilisation non autorisée du contenu du Site est strictement interdite et peut entraîner des poursuites judiciaires.
        </div>
      </article>

      <!-- Article 6 -->
      <article id="article-6" class="cgu-article">
        <div class="article-number">Article 6</div>
        <h2>Données Personnelles</h2>
        <p>
          Digital Alchemy s'engage à respecter la confidentialité des données personnelles des Utilisateurs conformément au Règlement Général sur la Protection des Données (RGPD) et à la législation marocaine applicable.
        </p>
        <h3>Collecte des données</h3>
        <p>
          Les données personnelles collectées via le Site peuvent inclure :
        </p>
        <ul>
          <li>Nom et prénom</li>
          <li>Adresse email</li>
          <li>Numéro de téléphone</li>
          <li>Nom de l'entreprise</li>
          <li>Informations relatives au projet</li>
        </ul>
        <h3>Finalité du traitement</h3>
        <p>
          Les données collectées sont utilisées pour :
        </p>
        <ul>
          <li>Répondre aux demandes de devis et de contact</li>
          <li>Fournir les services demandés</li>
          <li>Améliorer nos services</li>
          <li>Envoyer des communications marketing (avec consentement)</li>
        </ul>
        <h3>Droits des utilisateurs</h3>
        <p>
          Conformément à la réglementation, vous disposez des droits suivants :
        </p>
        <ul>
          <li>Droit d'accès à vos données</li>
          <li>Droit de rectification</li>
          <li>Droit à l'effacement</li>
          <li>Droit d'opposition</li>
          <li>Droit à la portabilité</li>
        </ul>
        <p>
          Pour exercer ces droits, contactez-nous à : <strong>Digitalalchemyma&#64;gmail.com</strong>
        </p>
      </article>

      <!-- Article 7 -->
      <article id="article-7" class="cgu-article">
        <div class="article-number">Article 7</div>
        <h2>Cookies</h2>
        <p>
          Le Site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic.
        </p>
        <h3>Types de cookies utilisés</h3>
        <ul>
          <li><strong>Cookies essentiels :</strong> Nécessaires au fonctionnement du Site</li>
          <li><strong>Cookies analytiques :</strong> Pour comprendre comment les visiteurs utilisent le Site</li>
          <li><strong>Cookies de performance :</strong> Pour améliorer les performances du Site</li>
        </ul>
        <p>
          Vous pouvez à tout moment désactiver les cookies via les paramètres de votre navigateur. Cependant, cela peut affecter votre expérience d'utilisation du Site.
        </p>
      </article>

      <!-- Article 8 -->
      <article id="article-8" class="cgu-article">
        <div class="article-number">Article 8</div>
        <h2>Responsabilités</h2>
        <h3>Responsabilité de Digital Alchemy</h3>
        <p>
          Digital Alchemy ne pourra être tenu responsable des dommages directs ou indirects causés au matériel de l'Utilisateur lors de l'accès au Site.
        </p>
        <p>
          Digital Alchemy décline toute responsabilité :
        </p>
        <ul>
          <li>En cas d'interruption du Site</li>
          <li>En cas d'impossibilité temporaire d'accès au Site</li>
          <li>En cas d'utilisation frauduleuse du Site par un tiers</li>
          <li>Pour tout préjudice indirect résultant de l'utilisation du Site</li>
        </ul>
        <h3>Responsabilité de l'Utilisateur</h3>
        <p>
          L'Utilisateur est seul responsable :
        </p>
        <ul>
          <li>De la protection de ses équipements et données</li>
          <li>De l'utilisation qu'il fait du Site</li>
          <li>Des informations qu'il transmet via le Site</li>
        </ul>
      </article>

      <!-- Article 9 -->
      <article id="article-9" class="cgu-article">
        <div class="article-number">Article 9</div>
        <h2>Liens Hypertextes</h2>
        <p>
          Le Site peut contenir des liens hypertextes vers d'autres sites internet. Digital Alchemy n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu, leur disponibilité ou leur politique de confidentialité.
        </p>
        <p>
          La mise en place de liens hypertextes vers le Site de Digital Alchemy est autorisée sous réserve :
        </p>
        <ul>
          <li>Que les pages du Site ne soient pas imbriquées dans un cadre (frame)</li>
          <li>Que le lien ouvre une nouvelle fenêtre du navigateur</li>
          <li>Que l'origine du lien soit clairement identifiable</li>
        </ul>
      </article>

      <!-- Article 10 -->
      <article id="article-10" class="cgu-article">
        <div class="article-number">Article 10</div>
        <h2>Droit Applicable et Juridiction Compétente</h2>
        <p>
          Les présentes CGU sont régies par le droit marocain et français selon la localisation de l'Utilisateur.
        </p>
        <p>
          En cas de litige relatif à l'interprétation ou à l'exécution des présentes CGU, les parties s'efforceront de le résoudre à l'amiable. À défaut d'accord amiable, le litige sera porté devant les juridictions compétentes.
        </p>
        <p>
          Pour les Utilisateurs situés au Maroc, les tribunaux de Rabat seront seuls compétents.
        </p>
        <p>
          Pour les Utilisateurs situés en France, les tribunaux français seront compétents selon les règles de droit commun.
        </p>
      </article>

      <!-- Contact Section -->
      <article class="cgu-article contact-article">
        <h2>Questions sur les CGU ?</h2>
        <p>
          Pour toute question concernant les présentes Conditions Générales d'Utilisation, vous pouvez nous contacter :
        </p>
        <div class="contact-info">
          <div class="contact-item">
            <strong>Par email :</strong> Contact&#64;digalchemy.com
          </div>
          <div class="contact-item">
            <strong>Par téléphone :</strong> +212 690 459 525 (Maroc) | +33 6 66 07 64 55 (France)
          </div>
          <div class="contact-item">
            <strong>Par courrier :</strong> Bd Dammam, Technopark Casablanca , Maroc . Rabat, Maroc
          </div>
        </div>
      </article>

    </div>
  </div>
</section>




<footer class="footer-section">
  <div class="footer-container">
    
    <!-- Main Footer Content -->
    <div class="footer-content">
      
      <!-- Section 1: Company Logo & Description -->
      <div class="footer-company">
        <div class="company-logo">
          <img src="assets/images/logo-white.png" alt="Rhillane Logo" />
        </div>
        
        <p class="company-description">
          Digital Alchemy, votre partenaire de confiance pour la création de sites web . 
          Nous transformons vos idées en succès digital avec des solutions innovantes et performantes.
        </p>
        
        <!-- Social Media -->
        <div class="social-media-section">
          <ul style="display: flex; gap: 16px; list-style: none; padding: 0; margin: 0;">
            
            <!-- Facebook -->
            <li style="margin: 0;">
              <a href="https://www.facebook.com/people/Digital-alchemy/61565618420833" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Facebook page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1877F2; fill: #1877F2;" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </li>
            
            <!-- Behance -->
            <li style="margin: 0;">
              <a href="https://www.behance.net/digitalalchemy2" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Behance page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1769FF; fill: #1769FF;" viewBox="0 0 24 24">
                  <path d="M0 4.4804V19.243h7.1554c.6613 0 1.3078-.0832 1.9297-.248.6288-.1654 1.1905-.4203 1.6792-.7661.485-.3431.8784-.7804 1.1677-1.3081.2862-.5258.4294-1.1471.4294-1.8641 0-.8784-.2067-1.6309-.6172-2.2506-.4073-.6172-.9897-1.0907-1.7494-1.4161.6388-.3431 1.1139-.8141 1.4285-1.4143.3146-.6002.4719-1.2755.4719-2.0274 0-.7193-.1327-1.3487-.4-1.8888-.2668-.5402-.6343-1.0033-1.0995-1.3914-.4652-.3881-.9712-.6884-1.5186-.8999C8.8135 4.5932 8.2071 4.4804 7.5446 4.4804H0zM15.3486 6.9795h4.7992v1.2755h-4.7992V6.9795zM3.2695 6.9795h3.8893c.9451 0 1.6612.2262 2.1463.6787.4851.4525.7277 1.0632.7277 1.8321 0 .8374-.2768 1.4676-.8323 1.8888-.5555.4212-1.2925.6323-2.2091.6323H3.2695V6.9795zM15.3486 13.2363h4.7992v1.2755h-4.7992v-1.2755zM3.2695 14.2834h4.3172c.6927 0 1.2944.1327 1.8051.3976.5107.2649.9378.6154 1.2755 1.0519.3377.4365.5849.9378.741 1.5044.1561.5666.2342 1.1543.2342 1.7632 0 .7193-.1014 1.3487-.3043 1.8888-.2029.5401-.5107.9949-.9237 1.3648-.4131.3699-.9378.6507-1.5743.8409-.6365.1902-1.3858.2853-2.2477.2853H3.2695v-7.0969z"/>
                </svg>
              </a>
            </li>
            
            <!-- LinkedIn -->
            <li style="margin: 0;">
              <a href="https://www.linkedin.com/company/digital-alchemy-ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our LinkedIn page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #0077B5; fill: #0077B5;" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </li>
            
            <!-- YouTube -->
            <li style="margin: 0;">
              <a href="https://www.youtube.com/@Digital_Alchemy_ma" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our YouTube page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #FF0000; fill: #FF0000;" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </li>
            
            <!-- Instagram -->
            <li style="margin: 0;">
              <a href="https://www.instagram.com/digital_alchemy_ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Instagram page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #E1306C; fill: #E1306C;" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </li>
            
          </ul>
        </div>
      </div>
      
      <!-- Section 2: Contact Information -->
      <div class="footer-contact">
        <h3 class="footer-title">CONTACT</h3>
        
        <div class="contact-info">
          <div class="contact-item">
            <span>+212 690 459 525</span>
          </div>
          <div class="contact-item">
            <span>+33 6 66 07 64 55</span>
          </div>
          <div class="contact-item">
            <span>Digitalalchemyma&#64;gmail.com</span>
          </div>
          <div class="contact-item">
            <span>Contact&#64;digalchemy.com</span>
          </div>
        </div>
        
        <div class="office-locations">
          <div class="office-item">
            <h4>NOTRE BUREAU AU MAROC</h4>
            <p>Bd Dammam, Technopark Casablanca , Maroc .</p>
          </div>
        </div>
      </div>
      
      <!-- Section 3: Services Column -->
      <div class="footer-links">
        <h3 class="footer-title">NOS SERVICES</h3>
        <ul class="footer-list">
          <li><a routerLink="/web">Sites Web</a></li>
<li><a routerLink="/appweb">Application Web</a></li>
          <li><a routerLink="/publicite">Publicité en ligne</a></li>
          <li><a routerLink="/gestion">Gestion des réseaux sociaux</a></li>
          <li><a routerLink="/design">Design Graphique</a></li>
          <li><a routerLink="/agence">Agence SEO</a></li>
        </ul>
      </div>
      
      <!-- Section 4: Quick Links Column -->
      <div class="footer-links">
        <h3 class="footer-title">LIENS RAPIDES</h3>
        <ul class="footer-list">
          <li><a routerLink="/">Accueil</a></li>
          <li><a routerLink="/apropos">À propos</a></li>
          <li><a routerLink="/contact">Contact</a></li>
          <li><a routerLink="/cgu">Conditions Générales d'Utilisation</a></li>
          <li><a routerLink="/conf">Politique de Confidentialité</a></li>
        </ul>
      </div>
      
    </div>
    
    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <p class="copyright">
          © {{ currentYear }} Digital Alchemy. Tous droits réservés. | 
          <a routerLink="/cgu">Mentions légales</a> | 
          <a routerLink="/conf">Politique des cookies</a>
        </p>
        <div class="footer-bottom-links">
          <a routerLink="/contact">Support</a>
        </div>
      </div>
    </div>
    
  </div>
</footer>